export default __webpack_public_path__ + "static/media/Footer_logo.22def309.svg";